// initialed state
export const initialState = () => ({
	content: {
		tableViewer: {},
		// {
		//    [title]: {
		//	 	columnDefsFromPreviousSteps: [],
		//	 	rowsFromPreviousSteps: [],
		//	},
	},
	isShowKnob: false,
	isSideBarDrawerOpen: false,
});

const state = initialState();

export default state;
